const usuario = angular.module('usuario', [])

usuario.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'usuario',
            redirectTo: 'admin.usuario'
        },
        {
            name: 'admin.usuario',
            url: '/minhaconta/{view:dados|endereco|faturas}',
            params: { view: { dynamic: true, value: 'dados' }, showGlobalLoading: { dynamic: true, value: true } },
            component: 'usuario.usuarioComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);